import { FC, useContext, useState, useEffect } from "react";
import { getStudentIdentifiedData } from "../../../../hooks/common";
import moment from "moment";
import CustomerDataContext from "../../../../store/CustomerData-context";
import ConstantsContext from "../../../../store/Constants-context";
interface records {
  student_year_level: string;
  full_name: string;
  last_seen: string;
  people_people_id: string;
  selectedDate: string;
}
interface Props {
  date: string;
  users: any[];
  yearLevel: string;
  customerType: string;
}
const NotSeenOneHour: FC<Props> = ({
  date,
  users = [],
  yearLevel = "",
  customerType = "",
}) => {
  const customerCtx = useContext(CustomerDataContext);
  const [notSeenCount, setNotSeenCount] = useState(0);
  const [notSeenRecords, setNotSeenRecords] = useState<records[]>([]);
  const constantsCtx = useContext(ConstantsContext);
  useEffect(() => {
    let table_data: records[] = [];

    const getRecords = async () => {
      let students = users.filter((user: { person_type: string }) => {
        // extract students from the user list
        return user.person_type === "student";
      });
      // extracting student ids
      let studentIds = students.filter((student: { people_id: string }) => {
        return student.people_id; // extracting student ids
      });
      let identifiedStudents = {
        identified_people: [],
        last_seen_people: [],
      };
      try {
        // let studentIdentifiedData = await getStudentIdentifiedData('HOG1', '2019-03-05');    // for debugging
        let studentIdentifiedData = await getStudentIdentifiedData(
          studentIds.toString(),
          date
        );
        identifiedStudents = studentIdentifiedData.hasOwnProperty("returnData")
          ? { ...studentIdentifiedData.returnData }
          : identifiedStudents;

        // /* FILTER ONLY EXISTING STUDENTS DETAILS */
        if (identifiedStudents.identified_people !== undefined)
          identifiedStudents.identified_people =
            identifiedStudents.identified_people.filter(
              (object: { people_people_id: string }) =>
                studentIds.includes(object.people_people_id)
            );

        // /* FILTER ONLY EXISTING STUDENTS DETAILS */
        if (identifiedStudents.last_seen_people !== undefined)
          identifiedStudents.last_seen_people =
            identifiedStudents.last_seen_people.filter(
              (object: { people_people_id: string }) =>
                studentIds.includes(object.people_people_id)
            );

        if (customerType === "education")
          if (yearLevel === "ALL") {
            /*NOT SEEN - This is the code in the jquery app
                        $('#tblNotSeen tr').hide();
                        $('#tblNotSeen [data-ylevel="' + selected_year_level + '"]').show();
                        filtered_records = $('#tblNotSeen [data-ylevel="' + selected_year_level + '"]').length;
                        $('#not_seen').html(filtered_records);
                        if (filtered_records === 0) {
                            $('#tblNotSeen').hide();
                            $('#tbl_not_seen_no_records').show();
                            $('#tbl_not_seen_no_records').html('<tr><td>No records available...</td></tr>');
                        }*/
          }

        if (Object.keys(customerCtx.customer_data).includes("periods")) {
          let customerData: any = customerCtx.customer_data;
          if (customerData.periods !== undefined) {
            const allPeriods = JSON.parse(customerData.periods);
            let last_period: string | Date | number;
            if (allPeriods.length > 0) {
              last_period =
                moment().format("YYYY-MM-DD") +
                "T" +
                allPeriods[allPeriods.length - 1].endTime;
              last_period = new Date(last_period).getTime();
            } else {
              last_period = new Date().getTime();
            }

            if (last_period > new Date().getTime()) {
              let unidentifiedLastHour: {
                date_added: string;
                time_added: string;
              }[] = [];

              identifiedStudents.last_seen_people.map(
                (singleData: { date_added: string; time_added: string }) => {
                  let db_date = moment(
                    `${singleData.date_added}T${singleData.time_added}`
                  )
                    .utc()
                    .format("YYYY-MM-DD HH:mm:ss");
                  let current_date = moment()
                    .utc()
                    .format("YYYY-MM-DD HH:mm:ss");
                  if (
                    moment(current_date).diff(moment(db_date), "seconds") > 3600
                  ) {
                    unidentifiedLastHour.push(singleData);
                  }
                }
              );
              unidentifiedLastHour = unidentifiedLastHour.sort(
                (a: { time_added: string }, b: { time_added: string }) =>
                  a.time_added > b.time_added ? 1 : -1
              );
              unidentifiedLastHour.map((studentDetails: any) => {
                const student = students.find(
                  (info: { people_people_id: string; year_level: string }) => {
                    return (
                      info.people_people_id ===
                        studentDetails.people_people_id && info
                    );
                  }
                );
                table_data.push({
                  student_year_level: student
                    ? student.year_level
                    : "not_available",
                  full_name: studentDetails.full_name,
                  last_seen: `${studentDetails.room_name} | ${moment
                    .parseZone(
                      studentDetails.date_added +
                        "T" +
                        studentDetails.time_added
                    )
                    .format("HH:mm A")}`,
                  people_people_id: `${studentDetails.people_people_id}`,
                  selectedDate: date,
                });
              });
              setNotSeenCount(unidentifiedLastHour.length);
              setNotSeenRecords(table_data);
            }
          }
        }
      } catch (err) {
        console.error(`Error:: Failed try...catch! ${JSON.stringify(err)}`);
      }
    };
    getRecords();
  }, [customerCtx.customer_data, users, date, yearLevel]);
  return (
    <div className="col-xl-8 residentNotSeen">
      <div className="card card-dashboard card-stretch">
        {/* begin::Body */}
        <div className="card-body py-9">
          <div className="row">
            <div className="col-md-12">
              <h4 className="py-3">
                {constantsCtx.MEMBER_NAME} not seen in one hour :
              </h4>
            </div>
            <div className="col-md-4 align-items-center d-flex flex-grow-1 justify-content-center m-b-0 m-t-0">
              <h1>{notSeenCount}</h1>
            </div>
            <div className="col-md-8 text-center table-responsive">
              <table
                className="no-footer table align-middle gs-0 gy-5"
                id="tbl_not_seen_no_records"
              >
                <tbody>
                  {notSeenCount === 0 && (
                    <tr>
                      <td className="noRecords">No records available...</td>
                    </tr>
                  )}
                  {notSeenCount > 0 &&
                    notSeenRecords.map((rec) => {
                      <tr key={rec.full_name}>
                        <td style={{ width: "40%" }}>{rec.full_name}</td>
                        <td style={{ width: "60%" }}>
                          <span className="teal-text">Last Seen:</span>{" "}
                          {rec.last_seen}
                        </td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            href={`students_results.html?id=${rec.people_people_id}&date=${rec.selectedDate}`}
                          >
                            <i className="bi bi-chevron-right fs-1"></i>
                          </a>
                        </td>
                      </tr>
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { NotSeenOneHour };
